import {
  Heading as HeadingDS,
  Body as BodyDS,
  MaterialUICore,
  tokens,
} from '@iclinic/design-system';

const { styled } = MaterialUICore;

// tokens.opacity.level.light
const HEX_OPACITY_LIGHT = '28';
// tokens.opacity.level.medium
const HEX_OPACITY_MEDIUM = '51';
// opacity: 1
const HEX_OPACITY_FULL = 'FF';

export const CardStyled = styled('button')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  padding: `${tokens.spacing.sm} ${tokens.spacing.md}`,
  border: `${tokens.border.width.hairline} solid ${tokens.color.primary.light}`,
  borderRadius: tokens.border.radius.md,
  marginRight: tokens.spacing.md,
  cursor: 'pointer',
  background: tokens.color.primary.light + HEX_OPACITY_LIGHT,
  transition: 'background 0.2s',
  alignItems: 'center',
  '&:last-child': {
    marginRight: '0px',
  },
  '&:hover': {
    textDecoration: 'none',
    background: `${tokens.color.primary.light}${HEX_OPACITY_FULL}`,
  },
  '&:focus': {
    textDecoration: 'none',
  },
  '&:active': {
    background: tokens.color.primary.light + HEX_OPACITY_MEDIUM,
  },
  userSelect: 'none',
  [theme.breakpoints.down('xs')]: {
    flexDirection: 'row',
    padding: tokens.spacing.xs,
    marginRight: '0px',
    marginBottom: tokens.spacing.md,
    '&:last-child': {
      marginBottom: '0px',
    },
  },
}));

export const Heading = styled(HeadingDS)({});

export const Body = styled(BodyDS)({});

export const HeadingContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItem: 'center',
  marginBottom: tokens.spacing.xs,
  textAlign: 'center',
  width: '288px',
  [theme.breakpoints.down('xs')]: {
    order: 2,
    marginLeft: tokens.spacing.xs,
    textAlign: 'left',
    width: 'calc(50% - 24px)',
  },
}));

export const Image = styled('img')(({ theme }) => ({
  width: '200px',
  [theme.breakpoints.down('xs')]: {
    order: 1,
    width: `calc(50% - 24px)`,
  },
}));

export const ButtonContainer = styled('div')(({ theme }) => ({
  marginTop: tokens.spacing.md,
  textAlign: 'center',
  [theme.breakpoints.down('xs')]: {
    display: 'none',
  },
}));

export const LoadingContainer = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  height: '100%',
  paddingTop: 'calc(50% - 40px)',
  paddingLeft: 'calc(50% - 20px)',
  background: 'rgb(0,0,0,0.2)',
});
